import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { deletePriceMemoMaintenanceEndpoint } from '../../../common/endpoints';

export const deletePriceMemoData = createApi(deletePriceMemoMaintenanceEndpoint, 'DELETE');

const DeletePriceMemo = createSlice({
  name: 'DeletePriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deletePriceMemoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePriceMemoData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deletePriceMemoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeletePriceMemo.reducer;